<template>
    <div id="promo-element" :class="{empty: !moduleData}">
        <div class="module" v-if="moduleData" :class="moduleData.Background + ' ' + moduleData.Spacing" :id="moduleData.AnchorID">
            <h2 v-if="moduleData.Title && moduleData.ShowTitle">{{moduleData.Title}}</h2>
            <div :class="[containerClass, moduleData.Layout, oddCount]">
                <b-row v-if="moduleData.Layout === 'list'">
                    <b-col class="promo" :class="{featured: promo.Featured}" md="6" lg="4" v-for="(promo, index) in moduleData.Promos"
                           :key="'promo' + index" :style="'--animation-order:' + index">
                        <div class="promo-holder">
                            <div class="tags" v-if="promo.Tags">
                                <div class="tag" v-for="(tag,index) in promo.Tags" :class="tag.ColourClass">
                                    <p>
                                        <span :class="{small: tag.Subtitle}">{{tag.Title}}</span>
                                        <span class="large" v-if="tag.Subtitle">{{tag.Subtitle}}</span>
                                    </p>
                                </div>
                            </div>
                            <b-img v-bind="imageProps" v-if="promo.Featured" :src="promo.ImageNarrow"></b-img>
                            <div class="promo-img-container" v-else>
                                <b-img v-bind="imageProps" :src="promo.ImageWide"></b-img>
                                <p class="heading">{{promo.Title}}</p>
                            </div>
                            <div class="tint" v-if="promo.Featured"></div>
                            <div class="promo-content">
                                <p class="content">{{promo.Content}}</p>
                                <p class="price">{{promo.Price}}</p>
                                <a class="btn btn-light-outline" v-if="promo.CTA.ID" :href="promo.CTA.URL">{{promo.CTA.CTAText}}</a>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <div class="promo" v-else v-for="(promo,index) in moduleData.Promos.slice(0, 3)" :key="'promo' + index"
                     :style="'--animation-order:' + index">
                    <div class="promo-holder">
                        <div class="tags" v-if="promo.Tags">
                            <div class="tag" v-for="(tag,index) in promo.Tags" :class="tag.ColourClass">
                                <p>
                                    <span :class="{small: tag.Subtitle}">{{tag.Title}}</span>
                                    <span class="large" v-if="tag.Subtitle">{{tag.Subtitle}}</span>
                                </p>
                            </div>
                        </div>
                        <b-img class="shadow-heavy" v-bind="imageProps" v-if="moduleData.Layout === 'animated'" :src="promo.ImageNarrow"></b-img>
                        <b-img v-bind="imageProps" v-else :src="promo.ImageWide"></b-img>
                        <div class="tint"></div>
                        <div class="promo-content">
                            <p class="heading">{{promo.Title}}</p>
                            <p class="content">{{promo.Content}}</p>
                            <p class="price">{{promo.Price}}</p>
                            <a class="btn btn-dark-small" v-if="promo.CTA.ID" :href="promo.CTA.URL">{{promo.CTA.CTAText}}</a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="controls" v-if="showSlider">
                <button @click="scrollPromosLeft"><i class="fal fa-long-arrow-left"></i></button>
                <button @click="scrollPromosRight"><i class="fal fa-long-arrow-right"></i></button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "PromoElement",
        data() {
            return {
                imageProps: {
                    center: true
                },
                evenOdd: null
            }
        },
        props: {
            component: {
                type: Object,
            }
        },
        computed: {
            ...mapGetters(['getModuleData', 'getSettings']),
            moduleData() {
                return this.getModuleData(this.component.ID);
            },
            containerClass() {
                if (this.moduleData.Layout === 'list') {
                    return 'container';
                }
                if (this.moduleData.Layout === 'normal-list') {
                    return 'edge-container no-slider';
                }
                return 'edge-container';
            },
            oddCount() {
                let evenOdd = this.evenOdd;
                if (!evenOdd) {
                    let count = $('.edge-container.animated').length;
                    this.evenOdd = (count % 2 === 0) ? 'even' : 'odd';
                }

                return this.evenOdd;
            },

            showSlider() {
                let data = this.moduleData
                return data.Layout !== 'list' && data.Layout !== 'normal-list'
            }
        },
        methods: {
            scrollPromosLeft(e) {
                let container = $(e.target).closest('.module').find('.edge-container'),
                    promo = container.find('.promo'),
                    promoWidth = promo.outerWidth(true),
                    scroll = ((promoWidth * 3) - container.width()) / 2;

                container.stop().animate({scrollLeft: '-=' + scroll});
            },
            scrollPromosRight(e) {
                let container = $(e.target).closest('.module').find('.edge-container'),
                    promo = container.find('.promo'),
                    promoWidth = promo.outerWidth(true),
                    scroll = ((promoWidth * 3) - container.width()) / 2;
                container.stop().animate({scrollLeft: '+=' + scroll});
            }
        }
    }
</script>
